import styled from 'styled-components';
import { PromoCodeStyled } from '../PromoCodeStyled';

export const PromoCodeStyledAC = styled(PromoCodeStyled)`
    background: rgb(241, 239, 239);

    .promoCode {
        &__title {
            color: ${({ theme }) => theme.colors.black};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        &__input_label_success {
            width: 70%;
            left: 15%;
            background: ${({ theme }) => theme.colors.black2};
            color: ${({ theme }) => theme.colors.white};

            &::after {
                border-top: 7px solid ${({ theme }) => theme.colors.black2};
            }
        }

        &__input {
            border: 1px solid ${({ theme }) => theme.colors.grey9};
            color: ${({ theme }) => theme.colors.black};

            &_error {
                border-color: ${({ theme }) => theme.colors.danger};
            }
        }

        &__button {
            border: 1px solid ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.colors.primary};

            &:hover {
                color: ${({ theme }) => theme.colors.white};
                background: ${({ theme }) => theme.colors.primary};
            }
        }
    }
`;
